(() => {
  const initGallery = (root) => {
    const main = root.querySelector('[data-gallery-main]');
    if (!main) return;

    root.querySelectorAll('[data-gallery-thumb]').forEach((button) => {
      button.addEventListener('click', () => {
        const image = button.querySelector('img');
        if (!image) return;
        main.src = button.dataset.src;
        main.removeAttribute('srcset');
        main.removeAttribute('sizes');
        main.alt = button.dataset.alt || image.alt;
        root.querySelectorAll('[data-gallery-thumb]').forEach((thumb) => {
          thumb.setAttribute('aria-current', thumb === button ? 'true' : 'false');
        });
      });
    });
  };

  const initProductForm = (form) => {
    const variantSelect = form.querySelector('[name="id"]');
    const quantityInput = form.querySelector('[name="quantity"]');
    const productInfo = form.closest('.pawsy-buybox');
    const price = productInfo?.querySelector('[data-product-price]');
    const comparePrice = productInfo?.querySelector('[data-product-compare-price]');
    const saleBadge = productInfo?.querySelector('[data-product-sale-badge]');
    const submit = form.querySelector('[type="submit"]');
    const update = () => {
      const option = variantSelect?.selectedOptions[0];
      if (!option) return;
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (comparePrice) {
        comparePrice.textContent = option.dataset.comparePrice || '';
        comparePrice.hidden = !option.dataset.comparePrice;
      }
      if (submit) submit.disabled = option.dataset.available !== 'true';
      if (saleBadge) {
        saleBadge.hidden = !option.dataset.savings;
        saleBadge.textContent = option.dataset.savings ? `${saleBadge.dataset.prefix} ${option.dataset.savings}%` : '';
      }
      form.querySelectorAll('[data-product-submit-label]').forEach((label) => {
        label.textContent = option.dataset.available === 'true' ? label.dataset.availableLabel : label.dataset.soldOutLabel;
      });
      if (option.dataset.image) {
        const mainImage = form.closest('.pawsy-product__grid, .pawsy-spotlight__grid')?.querySelector('[data-gallery-main]');
        if (mainImage) {
          mainImage.src = option.dataset.image;
          mainImage.removeAttribute('srcset');
          mainImage.removeAttribute('sizes');
        }
      }
    };

    variantSelect?.addEventListener('change', update);
    form.querySelectorAll('[data-quantity-change]').forEach((button) => {
      button.addEventListener('click', () => {
        const change = Number(button.dataset.quantityChange);
        const minimum = Number(quantityInput?.min || 1);
        const current = Number(quantityInput?.value || minimum);
        if (quantityInput) quantityInput.value = String(Math.max(minimum, current + change));
      });
    });
    if (variantSelect) update();
  };

  const initReviews = (root) => {
    const track = root.querySelector('[data-review-track]');
    if (!track) return;
    root.querySelectorAll('[data-review-scroll]').forEach((button) => {
      button.addEventListener('click', () => {
        track.scrollBy({ left: button.dataset.reviewScroll === 'next' ? track.clientWidth * 0.8 : -track.clientWidth * 0.8, behavior: 'smooth' });
      });
    });
  };

  let revealObserver;
  const initialize = (root = document) => {
    root.querySelectorAll('[data-pawsy-gallery]').forEach(initGallery);
    root.querySelectorAll('[data-pawsy-product-form]').forEach(initProductForm);
    root.querySelectorAll('[data-pawsy-reviews]').forEach(initReviews);
    if (revealObserver) root.querySelectorAll('[data-pawsy-reveal]').forEach((element) => revealObserver.observe(element));
  };

  initialize();

  if ('IntersectionObserver' in window && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    document.documentElement.classList.add('pawsy-motion');
    revealObserver = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          revealObserver.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('[data-pawsy-reveal]').forEach((element) => revealObserver.observe(element));
  }

  document.addEventListener('shopify:section:load', (event) => initialize(event.target));
})();
